<template>
  <d-card class="card-small mb-3">

    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">Assign Actions</h6>
    </d-card-header>

    <d-card-body class="p-0">
      <d-list-group flush v-if="data && data.actions && data.actions.length > 0">
        <!-- Categories -->
        <d-list-group-item class="px-3 pb-2">
          <d-checkbox @change.native="updateAction" v-model="selected" class="mb-1" :value="action.button_text" v-for="(action,ind) in data.actions" :key="ind">{{action.button_text}}</d-checkbox>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
  </d-card>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'sidebar-categories',
   data(){
    return {
      selected:[]
    }
  },
   computed:{
    ...mapState({
        data:state=>state.actions.data,
        error:state=>state.actions.error,
    })
  },
  methods:{
     updateAction(){
       this.$nextTick(function(){
         this.$emit('actionAssigned',this.selected);
       })
    }
  },
  watch:{
    selectedTier(newTier){
      if(newTier){
        this.selected = newTier.actions.map(action=>{
          return action.button_text;
        });
      }
    },
    addButton(addBtn){
      if(addBtn){
        this.selected = [];
        this.updateAction();
      }
    }
  },
  props: {
    /**
     * The component's title.
     */
    addButton:{type:Boolean, default:true},
    selectedTier:{type:Object,default:()=>null},
    title: {
      type: String,
      default: 'Associated Actions',
    },
  },
};
</script>
